import React from 'react';
import AppsContainer from '@tenant/core/AppsContainer';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ROUTE_STRING } from 'constants/RouteString';
import PipelineTable from './components/List/PipelineTable';

// Pipelines list page (AC-1..AC-4). Grouped-by-App-Instance table + search + Create CTA
// live in PipelineTable; this is the routed shell, mirroring appInstance/List.js. Gated on
// PIPELINE_READ in ./index.js.
const ListPipeline = () => {
  return (
    <AppsContainer
      fullView
      title={
        <Breadcrumbs aria-label='breadcrumb'>
          <Typography color='text.primary'>Deployment</Typography>
          <Typography color='text.primary'>
            <Link to={ROUTE_STRING.PIPELINE.LIST}>Pipelines</Link>
          </Typography>{' '}
        </Breadcrumbs>
      }
    >
      <Box
        sx={{
          '& .MuiDataGrid-root': {
            borderLeft: 0,
            borderRight: 0,
            borderTop: 0,
            borderRadius: 0,
          },
        }}
      >
        <PipelineTable />
      </Box>
    </AppsContainer>
  );
};

export default React.memo(ListPipeline);
